// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__qTGyQ","title":"Info_title__2N5a9","links":"Info_links__1rZrA","link":"Info_link__2P58K","logo":"Info_logo__rs_bN"};